// // src/pages/modules/TicketHandlerProductivityReportPage.jsx

// import React, { useEffect, useState, useCallback } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   fetchTicketHandlerProductivityReport,
//   exportTicketHandlerProductivityReport,
//   clearError,
// } from 'store/slices/reportSlice';

// import PageHeader from 'components/common/PageHeader';
// import { Card, CardHeader, CardTitle, CardContent } from 'components/ui/card';
// import { Badge } from 'components/ui/badge';
// import { User, TrendingUp, TrendingDown } from 'lucide-react';
// import { toast } from 'sonner';
// import LogDateFilter from 'components/common/LogDateFilter';
// import DataTable from 'components/common/DataTable';
// import { Loader2 } from 'lucide-react';
// import { format } from 'date-fns';

// const TicketHandlerProductivityReportPage = () => {
//   const dispatch = useDispatch();

//   const {
//     ticketHandlerProductivityReport = { data: { summary: {}, results: [] }, pagination: null },
//     isLoading,
//     error,
//   } = useSelector((state) => state.report);

//   const summary = ticketHandlerProductivityReport.data.summary || {};
//   const results = ticketHandlerProductivityReport.data.results || [];
//   const pagination = ticketHandlerProductivityReport.pagination || {};

//   const [page, setPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [dateFilters, setDateFilters] = useState({});

//   // Calculate total pages from server response with fallback
//   const totalPages = pagination.total_pages || 1;

//   const refetch = useCallback(() => {
//     dispatch(
//       fetchTicketHandlerProductivityReport({
//         page,
//         page_size: pageSize,
//         search: searchTerm,
//         ...dateFilters,
//       })
//     );
//   }, [dispatch, page, pageSize, searchTerm, dateFilters]);

//   useEffect(() => {
//     refetch();
//   }, [refetch]);

//   useEffect(() => {
//     if (error) {
//       toast.error(error);
//       dispatch(clearError());
//     }
//   }, [error, dispatch]);

//   // Reset to page 1 when search term or page size changes
//   useEffect(() => {
//     setPage(1);
//   }, [searchTerm, pageSize]);

//   const columns = [
//     {
//       accessorKey: 'handler_name',
//       header: 'Handler Name',
//       cell: ({ row }) => (
//         <div className="flex items-center gap-2">
//           <User className="h-4 w-4 text-muted-foreground" />
//           <span className="font-medium">{row.original.handler_name}</span>
//         </div>
//       ),
//     },
//     {
//       accessorKey: 'total_assigned',
//       header: 'Total Assigned',
//       cell: ({ row }) => (
//         <Badge variant="outline" className="text-lg font-semibold">
//           {row.original.total_assigned}
//         </Badge>
//       ),
//     },
//     {
//       accessorKey: 'resolved',
//       header: 'Resolved',
//       cell: ({ row }) => (
//         <Badge variant="default" className="text-lg font-semibold">
//           {row.original.resolved}
//         </Badge>
//       ),
//     },
//     {
//       accessorKey: 'avg_resolution_time',
//       header: 'Avg Resolution Time',
//       cell: ({ row }) => (
//         <span className="font-medium">{row.original.avg_resolution_time || 'N/A'}</span>
//       ),
//     },
//     {
//       accessorKey: 'total_tickets',
//       header: 'Total Tickets',
//       cell: ({ row }) => (
//         <span className="font-medium">{row.original.total_tickets}</span>
//       ),
//     },
//   ];

//   return (
//     <div className="space-y-6 animate-fade-in">
//       <PageHeader
//         title="Handler Productivity Report"
//         description="Analyze ticket resolution performance by handler"
//       />

//       <LogDateFilter onFilter={(f) => setDateFilters(f)} />

//       {/* Summary Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//         <Card>
//           <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
//             <CardTitle className="text-sm font-medium">Total Handlers</CardTitle>
//             <User className="h-4 w-4 text-muted-foreground" />
//           </CardHeader>
//           <CardContent>
//             <div className="text-2xl font-bold">{pagination.count || 0}</div>
//           </CardContent>
//         </Card>

//         <Card>
//           <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
//             <CardTitle className="text-sm font-medium">Total Assigned</CardTitle>
//             <TrendingUp className="h-4 w-4 text-green-600" />
//           </CardHeader>
//           <CardContent>
//             <div className="text-2xl font-bold text-green-600">
//               {summary.total_assigned || 0}
//             </div>
//           </CardContent>
//         </Card>

//         <Card>
//           <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
//             <CardTitle className="text-sm font-medium">Total Resolved</CardTitle>
//             <TrendingUp className="h-4 w-4 text-green-600" />
//           </CardHeader>
//           <CardContent>
//             <div className="text-2xl font-bold text-green-600">
//               {summary.total_resolved || 0}
//             </div>
//           </CardContent>
//         </Card>

//         <Card>
//           <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
//             <CardTitle className="text-sm font-medium">Avg Resolution Time</CardTitle>
//             <User className="h-4 w-4 text-muted-foreground" />
//           </CardHeader>
//           <CardContent>
//             <div className="text-2xl font-bold">
//               {summary.avg_resolution_time || 'N/A'}
//             </div>
//           </CardContent>
//         </Card>
//       </div>

//       {isLoading && results.length === 0 ? (
//         <div className="flex items-center justify-center py-20">
//           <Loader2 className="h-10 w-10 animate-spin mr-3" />
//           <span className="text-lg">Loading handler productivity data...</span>
//         </div>
//       ) : (
//         <DataTable
//           data={results} // Use the paginated results from the server
//           columns={columns}
//           searchPlaceholder="Search by handler name..."
//           onSearch={setSearchTerm}
//           showSearch={true}
//           pageIndex={page - 1} // Convert to 0-based index for DataTable
//           pageSize={pageSize}
//           pageCount={totalPages} // Use total pages from server response
//           onPageChange={(p) => setPage(p + 1)} // Convert back to 1-based index
//           onPageSizeChange={(newSize) => setPageSize(newSize)} // Page reset is handled by useEffect
//           isLoading={isLoading}
//           onExport={() =>
//             dispatch(exportTicketHandlerProductivityReport({ filters: { ...dateFilters, search: searchTerm } }))
//           }
//           showExport={true}
//           showImport={false}
//         />
//       )}
//     </div>
//   );
// };

// export default TicketHandlerProductivityReportPage;


// src/pages/modules/TicketHandlerProductivityReportPage.jsx

import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchTicketHandlerProductivityReport,
  exportTicketHandlerProductivityReport,
  clearError,
} from 'store/slices/reportSlice';
import { fetchEmployeeDropdown } from 'store/slices/commonSlice';

import PageHeader from 'components/common/PageHeader';
import { Card, CardHeader, CardTitle, CardContent } from 'components/ui/card';
import { Badge } from 'components/ui/badge';
import { Button } from 'components/ui/button';
import { Label } from 'components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'components/ui/select';
import { User, TrendingUp, TrendingDown, Filter, X, ChevronDown, ChevronUp } from 'lucide-react';
import { toast } from 'sonner';
import LogDateFilter from 'components/common/LogDateFilter';
import DataTable from 'components/common/DataTable';
import { Loader2 } from 'lucide-react';
import { format } from 'date-fns';
import { Input } from 'components/ui/input';
import FormField from 'components/common/FormField';

const TicketHandlerProductivityReportPage = () => {
  const dispatch = useDispatch();

  const {
    ticketHandlerProductivityReport = { data: { summary: {}, results: [] }, pagination: null },
    isLoading,
    error,
  } = useSelector((state) => state.report);

  const summary = ticketHandlerProductivityReport.data.summary || {};
  const results = ticketHandlerProductivityReport.data.results || [];
  const pagination = ticketHandlerProductivityReport.pagination || {};

  // Get employees from Redux state
  const employees = useSelector((state) => state.common?.employees?.items || []);
  const employeesLoading = useSelector((state) => state.common?.employees?.loading || false);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [dateFilters, setDateFilters] = useState({});
  const [isAdvancedFilterExpanded, setIsAdvancedFilterExpanded] = useState(false);
  
  // Advanced filter states
  const [advancedFilters, setAdvancedFilters] = useState({
    assigned_to: 'all',
    min_assigned: '',
    max_assigned: '',
    min_resolved: '',
    max_resolved: '',
  });

  // Calculate total pages from server response with fallback
  const totalPages = pagination.total_pages || 1;

  // Check if any advanced filters are active (excluding 'all' values)
  const hasActiveAdvancedFilters = Object.values(advancedFilters).some(value => 
    value !== '' && value !== 'all'
  );

  const refetch = useCallback(() => {
    // Build the API params object with all filters
    const apiParams = {
      page,
      page_size: pageSize,
      search: searchTerm,
      report_type: 'handler_productivity',
      ...dateFilters,
      // Add advanced filters with proper naming for the backend
      ...(advancedFilters.assigned_to !== 'all' && { assigned_to: advancedFilters.assigned_to }),
      ...(advancedFilters.min_assigned && { min_assigned: advancedFilters.min_assigned }),
      ...(advancedFilters.max_assigned && { max_assigned: advancedFilters.max_assigned }),
      ...(advancedFilters.min_resolved && { min_resolved: advancedFilters.min_resolved }),
      ...(advancedFilters.max_resolved && { max_resolved: advancedFilters.max_resolved }),
    };
    
    
    dispatch(fetchTicketHandlerProductivityReport(apiParams));
  }, [dispatch, page, pageSize, searchTerm, dateFilters, advancedFilters]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch(clearError());
    }
  }, [error, dispatch]);

  // Reset to page 1 when search term, page size, or filters change
  useEffect(() => {
    setPage(1);
  }, [searchTerm, pageSize, dateFilters, advancedFilters]);

  // Fetch all employees on component mount
  useEffect(() => {
    dispatch(fetchEmployeeDropdown({}));
  }, [dispatch]);

  // --- Event Handlers ---
  const handleAdvancedFilterChange = (key, value) => {
    setAdvancedFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const resetAdvancedFilters = () => {
    setAdvancedFilters({
      assigned_to: 'all',
      min_assigned: '',
      max_assigned: '',
      min_resolved: '',
      max_resolved: '',
    });
  };

  const columns = [
    {
      accessorKey: 'assigned_to__first_name',
      header: 'Handler Name',
      cell: ({ row }) => (
        <div className="flex items-center gap-2">
          <User className="h-4 w-4 text-muted-foreground" />
          <span className="font-medium">
            {`${row.original.assigned_to__first_name} ${row.original.assigned_to__last_name}`}
          </span>
        </div>
      ),
    },
    {
      accessorKey: 'assigned_to__code',
      header: 'Employee Code',
      cell: ({ row }) => (
        <Badge variant="outline" className="text-sm">
          {row.original.assigned_to__code}
        </Badge>
      ),
    },
    {
      accessorKey: 'total_assigned',
      header: 'Total Assigned',
      cell: ({ row }) => (
        <Badge variant="outline" className="text-lg font-semibold">
          {row.original.total_assigned}
        </Badge>
      ),
    },
    {
      accessorKey: 'resolved',
      header: 'Resolved',
      cell: ({ row }) => (
        <Badge variant="default" className="text-lg font-semibold">
          {row.original.resolved}
        </Badge>
      ),
    },
    {
      accessorKey: 'closed',
      header: 'Closed',
      cell: ({ row }) => (
        <Badge variant="secondary" className="text-lg font-semibold">
          {row.original.closed}
        </Badge>
      ),
    },
  ];

  return (
    <div className="space-y-6 animate-fade-in">
      <PageHeader
        title="Handler Productivity Report"
        description="Analyze ticket resolution performance by handler"
      />

      {/* <LogDateFilter onFilter={(f) => setDateFilters(f)} /> */}

      {/* Advanced Filters Card */}
      <Card>
        <CardHeader className="pb-2">
          <div className="flex items-center justify-between">
            <CardTitle className="text-lg flex items-center gap-2">
              <Filter className="h-5 w-5" />
              Advanced Filters
              {hasActiveAdvancedFilters && (
                <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">
                  Active
                </span>
              )}
            </CardTitle>
            <div className="flex gap-2">
              {hasActiveAdvancedFilters && (
                <Button variant="outline" size="sm" onClick={resetAdvancedFilters}>
                  <X className="h-4 w-4 mr-1" />
                  Reset
                </Button>
              )}
              <Button 
                variant="ghost" 
                size="sm" 
                onClick={() => setIsAdvancedFilterExpanded(!isAdvancedFilterExpanded)}
              >
                {isAdvancedFilterExpanded ? (
                  <>
                    Hide <ChevronUp className="h-4 w-4 ml-1" />
                  </>
                ) : (
                  <>
                    Show <ChevronDown className="h-4 w-4 ml-1" />
                  </>
                )}
              </Button>
            </div>
          </div>
        </CardHeader>
        {isAdvancedFilterExpanded && (
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {/* <div className="space-y-2">
                <Label htmlFor="assigned_to">Handler</Label>
                <Select
                  value={advancedFilters.assigned_to}
                  onValueChange={(value) => handleAdvancedFilterChange('assigned_to', value)}
                  disabled={employeesLoading}
                >
                  <SelectTrigger>
                    <SelectValue placeholder={employeesLoading ? "Loading..." : "Select handler"} />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">All Handlers</SelectItem>
                    {Array.isArray(employees) && employees.map((employee) => (
                      <SelectItem key={employee.id} value={employee.id}>
                        {employee.name}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div> */}
              <FormField
  label="Handler"
  name="assigned_to"
  type="select"
  value={advancedFilters.assigned_to}
  onChange={(e) => handleAdvancedFilterChange('assigned_to', e.target.value)}
  disabled={employeesLoading}
  options={[
    { value: 'all', label: 'All Handlers' },
    ...(Array.isArray(employees)
      ? employees.map((employee) => ({
          value: String(employee.id),
          label: employee.name,
        }))
      : []),
  ]}
  placeholder={employeesLoading ? "Loading..." : "Select handler"}
/>

              
              <div className="space-y-2">
                <Label>Assigned Range</Label>
                <div className="grid grid-cols-2 gap-2">
                  <div>
                    <Input
                      type="number"
                      placeholder="Min"
                      value={advancedFilters.min_assigned}
                      onChange={(e) => handleAdvancedFilterChange('min_assigned', e.target.value)}
                    />
                  </div>
                  <div>
                    <Input
                      type="number"
                      placeholder="Max"
                      value={advancedFilters.max_assigned}
                      onChange={(e) => handleAdvancedFilterChange('max_assigned', e.target.value)}
                    />
                  </div>
                </div>
              </div>
              
              <div className="space-y-2">
                <Label>Resolved Range</Label>
                <div className="grid grid-cols-2 gap-2">
                  <div>
                    <Input
                      type="number"
                      placeholder="Min"
                      value={advancedFilters.min_resolved}
                      onChange={(e) => handleAdvancedFilterChange('min_resolved', e.target.value)}
                    />
                  </div>
                  <div>
                    <Input
                      type="number"
                      placeholder="Max"
                      value={advancedFilters.max_resolved}
                      onChange={(e) => handleAdvancedFilterChange('max_resolved', e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </CardContent>
        )}
      </Card>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Total Handlers</CardTitle>
            <User className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{summary.total_handlers || 0}</div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Total Resolved</CardTitle>
            <TrendingUp className="h-4 w-4 text-green-600" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-green-600">
              {summary.total_resolved || 0}
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Top Handler</CardTitle>
            <TrendingUp className="h-4 w-4 text-orange-600" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-orange-600">
              {summary.top_handler || 'N/A'}
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Avg Resolved per Handler</CardTitle>
            <User className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">
              {summary.avg_resolved_per_handler || '0.0'}
            </div>
          </CardContent>
        </Card>
      </div>

      {/* {isLoading && results.length === 0 ? (
        <div className="flex items-center justify-center py-20">
          <Loader2 className="h-10 w-10 animate-spin mr-3" />
          <span className="text-lg">Loading handler productivity data...</span>
        </div>
      ) : ( */}
        <DataTable
          data={results} // Use the paginated results from the server
          columns={columns}
          totalCount={pagination.count}
          searchPlaceholder="Search by handler name..."
          onSearch={setSearchTerm}
          showSearch={true}
          pageIndex={page - 1} // Convert to 0-based index for DataTable
          pageSize={pageSize}
          pageCount={totalPages} // Use total pages from server response
          onPageChange={(p) => setPage(p + 1)} // Convert back to 1-based index
          onPageSizeChange={(newSize) => setPageSize(newSize)} // Page reset is handled by useEffect
          isLoading={isLoading}
          onExport={() =>
            dispatch(exportTicketHandlerProductivityReport({ 
              filters: { 
                page,
                page_size: pageSize,
                search: searchTerm,
                report_type: 'handler_productivity',
                ...dateFilters,
                // Include advanced filters in export
                ...(advancedFilters.assigned_to !== 'all' && { assigned_to: advancedFilters.assigned_to }),
                ...(advancedFilters.min_assigned && { min_assigned: advancedFilters.min_assigned }),
                ...(advancedFilters.max_assigned && { max_assigned: advancedFilters.max_assigned }),
                ...(advancedFilters.min_resolved && { min_resolved: advancedFilters.min_resolved }),
                ...(advancedFilters.max_resolved && { max_resolved: advancedFilters.max_resolved }),
              } 
            }))
          }
          showExport={true}
          showImport={false}
        />
      {/* )} */}
    </div>
  );
};

export default TicketHandlerProductivityReportPage;